import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class WoodenShelf extends DestroyableObstacle {
	static key = "WoodenShelf";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.WOOD_DEBRIS;
	}

	static deserialize(data: any): WoodenShelf {
		const s = new WoodenShelf(deserializeXY(data.xy));
		s.restoreBaseFields(data);
		return s;
	}
}
